import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import CrudFinish from '../components/CrudFinish';
import i18n from '@/i18n';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabDetails', 'finishType.finishes'],
    names: ['details', 'finishes'],
    header: form => {
      return {
        props: {
          title: form.description || i18n.t('common.finishType')
        }
      };
    },
    groups: [
      {
        finishes: {
          type: CrudFinish,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'finishTypeID',
            permissionCode: 'Finish'
          }
        },
        description: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 32,
            required: true
          },
          rules: [{ validator: validatorRequire }]
        },
        finishTypeOption: {
          type: Select,
          defaultValue: '',
          props: {
            caption: 'common.finishType',
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('finishtype'),
            required: true
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        calculationMethodOption: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'finishType.calculationMethod',
            required: true,
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('quantityCalculationMethod')
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        measurementRequiredYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'finishType.measurementRequired',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        fabricWidthFactorRequiredYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'finishType.fabricWidthFactorRequired',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        extraFabricHeightApplicableYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'finishType.extraFabricHeightApplicable',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        extraFabricWidthApplicableYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'finishType.extraFabricWidthApplicable',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        requiredProductTypeID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'finishType.requiredProductType',
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['productType/isLoading'],
            options: vue.$store.getters['productType/loadedItems']
          }
        }
      }
    ]
  };
}

const layoutTabVariants = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['finishes']
    }
  ]
};
const layoutTabDetails = {
  named: true,
  sections: [
    {
      width: 100,
      fields: [
        'description',
        'finishTypeOption',
        'calculationMethodOption',
        'measurementRequiredYN',
        'fabricWidthFactorRequiredYN',
        'extraFabricHeightApplicableYN',
        'extraFabricWidthApplicableYN',
        'requiredProductTypeID'
      ]
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails, layoutTabVariants]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
